// RetryHeader.jsx
// Header component with icon and title

import React from 'react';
import { styles } from './styles';

const RetryHeader = () => {
  return (
    <>
      <span style={styles.icon}>🔄</span>
      <h2 style={styles.title}>Setup Needs to Continue</h2>
    </>
  );
};

export default RetryHeader;